import { z } from 'zod';
import { categoryKeySchema } from './enums';
/**
 * One window, computed on demand from the existing tables — no new store,
 * no scheduled rollup. 'all' means since the beginning; '30'/'90' are days
 * back from now. A single window per request (not three pre-computed ones)
 * keeps both the API and the types simple — the frontend just re-requests
 * when the admin picks a different one.
 */
export const reportsWindowSchema = z.enum(['30', '90', 'all']);
export const reportsQuerySchema = z.object({
    window: reportsWindowSchema.default('30'),
});
/** "Track discussions by category" / "identify common themes" — the category is the theme proxy here. */
export const categoryActivitySchema = z.object({
    mainCategoryId: z.string(),
    mainCategoryName: z.string(),
    categoryId: z.string(),
    categoryKey: categoryKeySchema,
    categoryName: z.string(),
    topicCount: z.number().int(),
    commentCount: z.number().int(),
});
/** "Monitor participation levels". */
export const contributorActivitySchema = z.object({
    userId: z.string(),
    displayName: z.string(),
    topicCount: z.number().int(),
    commentCount: z.number().int(),
    totalCount: z.number().int(),
});
export const moderationThroughputSchema = z.object({
    autoFlagged: z.number().int(),
    autoBlocked: z.number().int(),
    approved: z.number().int(),
    rejected: z.number().int(),
    userReported: z.number().int(),
});
/** "Analyse enhancement requests" / "review bug and issue trends" — Bug and Enhancement specifically, by week. */
export const weeklyCategoryTrendSchema = z.object({
    weekStart: z.coerce.date(),
    categoryKey: categoryKeySchema,
    count: z.number().int(),
});
export const reportsSummarySchema = z.object({
    window: reportsWindowSchema,
    generatedAt: z.coerce.date(),
    totals: z.object({
        topicCount: z.number().int(),
        commentCount: z.number().int(),
        activeMemberCount: z.number().int(),
        voteCount: z.number().int(),
    }),
    categoryActivity: z.array(categoryActivitySchema),
    topContributors: z.array(contributorActivitySchema),
    moderationThroughput: moderationThroughputSchema,
    weeklyTrends: z.array(weeklyCategoryTrendSchema),
});
//# sourceMappingURL=reporting.js.map